export default {
  appTypeListFromProject (state) {
    let list = state.appTypeListFromProject.filter(item => !item.created);

    list = list.sort((a, b) => a.app_type > b.app_type);

    return list;
  },

  app_type_name: (state, getters) => (id) => {
    let name = '';

    if (+id === 0) {
      name = '通用';
    }

    state.appTypeList.some(item => {
      if (+item.app_type === +id) {
        name = item.type_name;
        return true;
      }
      return false;
    });

    return name;
  },

  current_app_type_name (state, getters) {
    return state.app.current && state.app.current.app_type &&
      getters.app_type_name(state.app.current.app_type);
  },
};
